import {
  CatalogueCategories
} from '../models';

export const mapCatalogueCategories = (result) => {

  return new CatalogueCategories(result).mapToStandard();
};